<template>
    <div>
        <div class="text-center">
            <h1 class="text-3xl">Registrar cliente</h1>
        </div>
        <create-customer :key="formKey" @create="createCustomerComponent" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import CreateCustomer from "@/components/customers/CreateCustomer.vue";

export default {
    name: "NewCustomer",
    components: {
        CreateCustomer
    },
    data: () => ({ id: "", formKey: 0 }),
    computed: { ...mapGetters("control", ["backgroundColor"]) },
    methods: {
        ...mapActions("customers", ["createCustomer"]),
        async createCustomerComponent(user) {
            this.$loading.show();
            try {
                const data = await this.createCustomer(user);
                this.id = data.id;
                this.$analytics.trackEvent("customer_created");
                this.$loading.hide();
                this.$sound.play();
                const dialogResult = await this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Creación exitosa",
                    text: `Cliente creado con el Id: ${data.id}`,
                    icon: "success",
                    showDenyButton: true,
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonColor: "#02672D",
                    cancelButtonColor: "#253C99",
                    denyButtonColor: "#d33ddd",
                    confirmButtonText: "Ver detalle",
                    denyButtonText: "Ir a lista de clientes",
                    cancelButtonText: "Registrar cliente"
                });

                if (dialogResult.isConfirmed) {
                    this.id = data.id;
                    this.$router.push(`/app/customers/detail/${this.id}`);
                }
                if (dialogResult.isDenied) {
                    this.$router.push("/app/customers/");
                }
                if (dialogResult.dismiss === this.$swal.DismissReason.cancel) {
                    this.formKey += 1;
                }
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
